import { Component, Injector, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { NotfGravity, NotificationService, NotifType } from '@common/services';
import { InputBase } from '@ui/components/form/base/input-base';

@Component({
    selector: 'aa-input-copy-text2',
    templateUrl: './input-copy-text2.component.html',
    styleUrls: [
        '../input.component.scss',
        './input-copy-text2.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputCopyText2Component,
            multi: true,
        }],
    standalone: false
})
export class InputCopyText2Component extends InputBase<string>
{
    @Input() titleKey: string;
    @Input() messageKey: string;
    private static identifier = 0;

    constructor (
        injector: Injector,
        private notificationService: NotificationService
    )
    {
        super(injector);

        this.fieldId = `input-copy-text2-${InputCopyText2Component.identifier++}-id`;
    }

    public onCopy (text: any): void
    {
        if (!text)
        {
            return;
        }

        const listener = (e: ClipboardEvent) =>
        {
            const clipboard = e.clipboardData || window['clipboardData'];
            clipboard.setData('text', text.toString());
            e.preventDefault();
            this.notifyCopy();
        };

        document.addEventListener('copy', listener, false);
        document.execCommand('copy');
        document.removeEventListener('copy', listener, false);
    }

    notifyCopy ()
    {
        this.notificationService.notify(
            [
                '',
                this.messageKey,
            ],
            NotfGravity.success,
            NotifType.SNACKBAR
        );
    }
}
